<template>
  <div id="app-wrapper">
    <sidebar class="sidebar-container" :active="active" @toLink="toLink"/>
    <div class="main-container">
      <div class="fixed-header">
        <navbar v-if="!fromSaas" />
        <tabs @toTabLink="toTabLink" @addCache="addCache" @remoeCache="removeCache" ref="tabs"></tabs>
      </div>
      <app-main :cachePages="cachePages" />
      <!-- 机器人 -->
      <div v-if="!isSdLogin && !isHbgsLogin" id="parent" class="callback float" @click="onClick" @mousedown="down" @touchstart="down" @mousemove="move" @touchmove="move" @mouseup="end" @touchend="end" ref="fu">
        <div class="ask" ></div>
      </div>
    </div>
    <!-- 全局提示绑定手机号 -->
    <!-- <bind-phone ref="bindPhone" v-if="bindPhoneVisible" @close="bindPhoneVisible=false"></bind-phone> -->
    <div class="tips-image" v-if="centerDialogVisible" @click="handleCloseAll">
      <div>
        <img @click="toMarketCenter" class="active-img" src="https://web.nlktj.com/ty/merchant/oilSchool.png" alt="">
        <img @click="closeTips" class="close" src="../../assets/image/icon/closeImg.png" alt="">
      </div>
    </div>
    <!--全局弹窗是否有退款信息-->
    <el-dialog
      title="用户订单自动退款通知"
      :visible="refundDialogVisible"
      :close-on-click-modal="true"
      :before-close="closeRefund"
      width="600px"
      center>
      <div class="refund_content">
        <p>尊敬的客户您好：</p>
        <p>
          团油商户端产品目前已经为全量团油合作油站提供了技术以及服务支持。
          本次为了提升团油油站商户财务对账的效率以及油站商户端产品使用体验，
          平台对于用户退款进行了相应的规范。同时对于商户油站侧增加油站拒绝退款上传凭证入口，
          支持上传视频或照片，同时对于商户处理用户申请退款增加30天的处理时效限制，
          超过30天未上传相关凭证拒绝的退款订单将自动完成订单退款。以上所述功能自通知发布之日起生效。如有对此功能有异议可点击联系客服反馈您的意见。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="refund_cancal"  @click="handleRelation">联系客服</el-button>
        <el-button class="refund_confirm" type="primary" @click="agreeCheckApi">我知道了</el-button>
      </span>
    </el-dialog>
    <div class="image-pop" v-if="popShow" @click.self="closePopMask(1)">
      <!--平铺和富文本的才支持强制阅读-->
      <div class="mask" v-if="btnText && popList[0].materialForm === 2"></div>
      <div class="pop-box">
        <!--平铺设置-->
        <div :class="[popList[imgShowIndex].adContent ? ' ping_padd' : '', 'img-box']" v-if="popList[0].materialForm === 2">
          <template v-if="popList[imgShowIndex].adContent">
            <div v-html="getXssIntro(popList[imgShowIndex].adContent)"></div>
          </template>
          <template v-else>
            <img class="img" :src="popList[imgShowIndex].image" alt="">
          </template>
        </div>
        <!--轮播设置-->
        <el-carousel class="img-box" height="550px" v-else @change="cahngeIndex" :interval='popList[0].timeInterval * 1000'>
          <el-carousel-item v-for="item in popList" :key="item.id">
            <img class="img" :src="item.image" alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="btn-box">
          <p class="click-btn" @click="btnClick(popList[imgShowIndex].id)">{{popList[imgShowIndex].linkButton || '我知道了'}}<span v-if="btnText && popList[0].materialForm === 2">({{btnText}})秒</span></p>
        </div>
        <img v-if="!isAdTime && popList[0].materialForm === 2" @click="closePop(1)" class="close" src="../../assets/image/icon/closeImg.png" alt="">
      </div>
    </div>
    <Rule ref="rulePop" @closePop="closeRulePop" v-if="showRule"></Rule>
    <ChannelFeeNotice ref="channelFeePop" v-if="showChannelFeeNotice" @confirm-success="onChannelFeeConfirmed" @close="showChannelFeeNotice = false"></ChannelFeeNotice>
  </div>
</template>
<script>
import * as ItemTool from './components'
import { registerAndLoginXet, isAgreeCheck, agreeCheck, readRule } from '@/api/common'
import { violationRecordNotice } from '@/api/ruleCenter/index'
import { getRefundNum } from '@/api/order'
import { gasLicenceExpiryTips, queryGasInfoCheckNotice, getGasMsg, billInvoiceNotification } from '@/api/gasStationManage/gasInfo'
// import BindPhone from '@/views/account/components/BindPhone'
import { mapState, mapActions, mapGetters } from 'vuex'
// import { isShowBindPhoneApi } from '@/api/login'
import { getFailVoiceOrder } from '@/api/merchantCenter/voice'
import { getAdvertisementList, readMark, getRulePop } from '@/api/homePop'
import { getLoginDisplay } from '@/api/login'
import WaterMark from '@/utils/waterPrint'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { getXssIntro } from '@/utils/xss'
// import webSocket from '@/utils/websocket'

let synth, msg
if (window.speechSynthesis && SpeechSynthesisUtterance) {
  synth = window.speechSynthesis
  msg = new SpeechSynthesisUtterance()
}

export default {
  name: 'Layout',
  components: {
    ...ItemTool
    // BindPhone
  },
  data () {
    return {
      isAdTime: '', // 是否有时间
      btnText: null, // 广告弹窗倒计时
      refundDialogVisible: false, // 全局退款弹框
      cachePages: [],
      active: '',
      bindPhoneVisible: false,
      centerDialogVisible: false,
      popShow: false,
      imgShowIndex: 0,
      popList: [],
      // 拖拽需求
      isLoading: false,
      flags: false, //控制使用
      position: {
      x: 0,
      y: 0,
      },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",
      firstTime: '',  // 开始时间
      lastTime: '', // 结束时间
      showRule: false,
      ruleTimmer: null,
      ruleTimeNum: 0,
      showChannelFeeNotice: false, // 通道费告知函确认弹窗
      // path: 'ws://192.168.0.200:8005/qrCodePage/ID=1/refreshTime=5',
      socket: '',
      // isSdLogin: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      fromSaas: state => state.user.fromSaas,
      pageIndexProtocol: state => state.user.userInfo.pageIndexProtocol,
      openVoice: state => state.user.openVoice,
      isKnowRefund: state => state.isRefund.isKnowRefund,
    }),
    ...mapGetters(['isHbgsLogin', 'isSdLogin'])
  },
  watch: {
    openVoice (val) {
      if (synth && msg && !val) synth.cancel()
    }
  },
  methods: {
    getXssIntro,
    ...mapActions('user', ['setOpenVoice']),
    ...mapActions('isRefund', ['setRefund']),
    ...mapActions('user', ['setProtocol']),
    // 退款弹窗联系客服按钮
    handleRelation () {
      window.qimoChatClick()
      this.refundDialogVisible = false
    },
    closeRefund () {
      this.refundDialogVisible = false
    },
    toLink (item) {
      const { meta } = item
      if (meta.id) this.$track.clickEvent(meta.trackName || meta.title, meta.id)
      this.active = item.fullPath
      if (this.$route.fullPath !== item.fullPath) {
        this.$refs.tabs.addTab(item)
      }
      this.getAdList(1)
      console.log(item)
      if(item.path === 'orderList') return
      this.getNeedReadRule()
    },
    toTabLink (item) {
      this.active = item.fullPath
      this.$router.push({ path: item.fullPath })
      this.$refs.tabs.addTab(item)
    },
    addCache (data) {
      if (!data.componentName || (data.meta && data.meta.noCache)) return
      // this.cachePages = [...new Set(this.cachePages.concat(data.componentName))]
      this.cachePages = this.cachePages.concat(data.componentName)
    },
    removeCache (index) {
      this.cachePages.splice(index, 1)
    },
    handleCloseAll () {
      this.closeTips()
    },
    changeMenuType () {
      this.active = this.$route.fullPath
      this.$refs.tabs.addTab(this.$route)
    },
    toMarketCenter () {
      this.centerDialogVisible = false
      this.$track.clickEvent('油站学堂弹窗上的跳转', '1628492425')
      this.oilStudy()
    },
    closeTips () {
      this.centerDialogVisible = false
      this.$track.clickEvent('弹窗关闭按钮', '1628492459')
    },
    down() {
      // 记录时间差，判断是点击事件 还是 拖拽事件
      document.getElementById('parent').setAttribute('drag-flag', false)
      this.firstTime = new Date().getTime()
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.fu.offsetLeft;
      this.dy = this.$refs.fu.offsetTop;
    },
    // 拖拽客服机器人
    move() {
      if (this.flags) {
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.nx = touch.clientX - this.position.x;
      this.ny = touch.clientY - this.position.y;
      this.xPum = this.dx + this.nx;
      this.yPum = this.dy + this.ny;
      let width = window.innerWidth - this.$refs.fu.offsetWidth; //屏幕宽度减去自身控件宽度
      let height = window.innerHeight - this.$refs.fu.offsetHeight; //屏幕高度减去自身控件高度
      this.xPum < 0 && (this.xPum = 0);
      this.yPum < 0 && (this.yPum = 0);
      this.xPum > width && (this.xPum = width);
      this.yPum > height && (this.yPum = height);
      this.$refs.fu.style.left = width - 20 + "px"; //  width 只允许在右侧移动，this.xPum 可以全局移动
      this.$refs.fu.style.top = this.yPum + "px";
      // }
      //阻止页面的滑动默认事件
      document.addEventListener(
        "touchmove",
        function () {
          event.preventDefault();
        },
          false
        )
      }
    },
    //鼠标释放时候的函数
    end() {
      this.lastTime = new Date().getTime()
      if (this.lastTime - this.firstTime > 200) {
        document.getElementById('parent').setAttribute('drag-flag', true)
      }
      this.flags = false;
    },
    // 客服机器人弹框
    onClick() {
      const isDrag = document.getElementById('parent').getAttribute('drag-flag')
      if (isDrag === 'true') return
      window.qimoChatClick()
      this.$track.clickEvent('我的管家', 1632832571)
    },
    // 是否同意自动退款接口
    async isAgreeCheckApi () {
      try {
        const { code, result } = await isAgreeCheck()
        if (code !== 200) return
        // true已签,false未签
        this.refundDialogVisible = !result.signed
        this.getRefundNum(result.signed)
        this.setRefund(result.signed)
      } catch (error) {
        console.log(error)
      }
    },
    // 同意自动退款
    async agreeCheckApi () {
      try {
        const { code, result } = await agreeCheck({ confirmStatus: 1 })
        if (code !== 200) return
        this.setRefund(true)
        console.log(result, '同意自动退款')
      } catch (error) {
        console.log(error)
      } finally {
        this.refundDialogVisible = false
      }
    },
    // 点击蒙版。有时间限制的，不让点
    closePopMask(type) {
      console.log(this.isAdTime, 'fffffff')
      if (this.isAdTime) return
      this.closePop(type)
    },
    // 关闭广告弹窗
    closePop (type) {
      this.readAd(this.popList[this.imgShowIndex].id)
      if (type) this.$track.clickEvent('PC首页弹窗关闭按钮', '1628492459', { tysj_trade_type: this.popList[this.imgShowIndex].id })
      if (this.popList[0].materialForm === 2) {
        // 平铺
        if (this.imgShowIndex === this.popList.length - 1) {
          // 最后一个平铺
          this.popShow = false
          this.imgShowIndex = 0
        } else {
          this.imgShowIndex++
          // 如果有时间，就开始倒计时
          // if (this.popList[this.imgShowIndex].forceReadSeconds) {
          this.countDown(this.popList[this.imgShowIndex].forceReadSeconds)
          // }
          this.$track.pageViewEvent('团油商家端PC首页弹窗', '1628493301', { tysj_trade_type: this.popList[this.imgShowIndex].id})
        }
      } else {
        // 关掉整个弹窗
        this.popShow = false
        this.imgShowIndex = 0
      }
    },
    // 倒计时
    countDown (adTime) {
      this.isAdTime = adTime
      if (!adTime) return // 如果不存在时间，就不倒计时
      let count = adTime
      this.btnText = count--
      this.timer = setInterval(() => {
        if (count === 0) {
          this.clearTimer()
          return
        }
        this.btnText = count--
      }, 1000)
    },
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
      this.btnText = null
    },
    // 关闭规则弹窗
    async closeRulePop () {
      try {
        const { code } = await readRule()
        if(code !== 200) return
          this.$track.clickEvent('我已同意并知晓', '1637816097', { tysj_page_time: this.ruleTimeNum })
          this.setProtocol(false)
      } catch (error) {
        console.log(error)
      } finally {
        this.showRule = false
        this.ruleTimeNum = 0
        clearInterval(this.ruleTimmer)
      }
    },
    // 通道费告知函：登录后展示检查（result 为 null 或 needRead=false 时不弹）
    async getChannelFeeNotice () {
      try {
        const { code, result } = await getLoginDisplay()
        if (code !== 200) return
        if (!result || !result.needRead) return
        this.showChannelFeeNotice = true
        this.$nextTick(() => {
          this.$refs.channelFeePop.init(result)
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 告知函确认成功
    onChannelFeeConfirmed () {
      this.showChannelFeeNotice = false
    },
    // 油站学堂,跳转第三方链接。
    async oilStudy () {
      try {
        const { code, result } = await registerAndLoginXet({ userId: this.userInfo.userId })
        if (code !== 200) return
        window.open(result.data.login_url)
      } catch (error) {
        console.log(error)
      }
    },
    handleSpeak (text) {
      msg.text = text;     // 文字内容: 小朋友，你是否有很多问号
      msg.lang = "zh-CN";  // 使用的语言:中文
      msg.volume = 1;      // 声音音量：1
      msg.rate = 1;        // 语速：1
      msg.pitch = 1;       // 音高：1
      synth.speak(msg);    // 播放
    },
    // 轮询语音播报
    intervalVoice (time = 5000) {
      setTimeout(async () => {
        if (!this.openVoice) {
          this.intervalVoice()
          return
        }
        try {
          const {code, result} = await getFailVoiceOrder({gasId: this.userInfo.gasId})
          if (code !== 200) return
          this.setOpenVoice(result.pcSwitch ? 1 : 0)
          if (result.pcSwitch) {
            let test = result.orderResponse.map(item => item.broadcast)
            this.handleSpeak(test.join('。'))
          }
          this.intervalVoice(result.pcTaskInterval * 1000)
        } catch (error) {
          console.log(error)
        }
      }, time)
    },
    // 判断浏览器是否支持语音播报
    async ifSupportVoice () {
      try {
        const {code, result} = await getFailVoiceOrder({gasId: this.userInfo.gasId})
        if (code !== 200) return
        if (result.pcSwitch && !synth && !msg) {
          this.$message.error('您的浏览器不支持播报功能')
          this.setOpenVoice(0)
        } else {
          this.intervalVoice()
        }
      } catch (error) {
        console.log(error)
      }
    },
    btnClick () {
      this.$track.clickEvent('PC首页弹窗上跳转/默认按钮', '1628492425', { tysj_trade_type: this.popList[this.imgShowIndex].id })
      const url = this.popList[this.imgShowIndex].linkUrl
      this.closePop()
      if (!url) return
      let reg = /^\//
      if (reg.test(url)) {
        this.$router.push({ path: url})
      } else {
        window.location.href = url
      }
    },
    cahngeIndex (now) {
      this.imgShowIndex = now
    },
    // 获取首页弹窗
    async getAdList (pageClickType) {
      try {
        const {code, result} = await getAdvertisementList({ adSpaceCode: 'pc_home', pageClickType })
        if (code !== 200) return
        this.popList = result
        if (result.length) {
          this.popShow = true
          this.$track.pageViewEvent('团油商家端PC首页弹窗', '1628493301', { tysj_trade_type: result[0].id})
          if (result[0].forceReadSeconds) {
            this.countDown(result[0].forceReadSeconds) // 倒计时
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 已读广告
    async readAd (adId) {
      try {
        await readMark({ adId })
      } catch (error) {
        console.log(error)
      }
    },
    // 获取规则弹窗
    async getNeedReadRule () {
      try {
        const {code, result } = await getRulePop()
        if (code !== 200) return
        this.showRule = result.needRead
        this.ruleContent = result
        if (!result.needRead) return
        this.$track.pageViewEvent('商户规则弹窗', '1637816096')
        clearInterval(this.ruleTimmer)
        this.ruleTimmer = setInterval(()=>{
          this.ruleTimeNum++
        },1000)
        this.$nextTick(() => {
          this.$refs.rulePop.init(result)
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 获取需要退款的订单数量
    async getRefundNum (isAgree) {
      try {
        const { code, result } = await getRefundNum()
        if (code !== 200) return
        const h = this.$createElement;
        this.$notify({
          title: '退款申请',
          message: h('p', {
            style: 'display: flex; flex-direction: column;'
          }, [
            h('span', { style: 'color: #606266; padding-top: 6px' }, `您有${result}笔退款中的订单。${isAgree ? '如申请退款时间超过30个自然日未处理，系统将自动退款' : ''}`),
            h('a',{
              style: 'color: #3377FF; padding-top: 8px',
              on: {
                click: this.clickToOrder, // 确定按钮的点击事件
              },
            }, "立即处理"),
          ]),
          duration: 8000
        })
      } catch (error) {
        console.log(error.message)
      }
    },
    open () {
      console.log("socket连接成功")
    },
    error () {
      console.log("连接错误")
    },
    getMessage (msg) {
      JSON.parse(msg.data).map(item => {
        this.openSocketMessage(item)
      })
    },
    send () {
      this.socket.send()
    },
    closewebsocket (msg) {
      console.log(msg, "socket已经关闭")
    },
    clickToOrder () {
      this.$router.push({ path: '/order/orderList', query: { isRefund: true } })
    },
    openSocketMessage(data) {
      const h = this.$createElement;
      this.$notify({
        title: '退款申请',
        message: h('p', {
          style: 'display: flex; flex-direction: column;'
        }, [
          h('span', { style: 'color: #606266; padding-top: 6px' }, `您有一条新的退款申请，订单号：${data.orderNo}。${data.autoRefundMsg || ''}`),
          h('a',{
            style: 'color: #3377FF; padding-top: 8px',
            on: {
              click: this.clickToOrder, // 确定按钮的点击事件
            },
          }, "立即处理"),
        ]),
        duration: 8000
      })
    },
    // 查询三证是否过期
    async gasLicenceExpiry () {
      const { code, result } = await gasLicenceExpiryTips({ cache: 0 })
      if (code !== 200) return
      let arr1 = ['gasBottleCertificatesDefectTips', 'gasCertificatesDefectTips', 'hcLicenseDefectTips', 'productDefectTips']
      result.map(item => {
        if (item) {
        let gasId = item.gasId
          for (let key in item) {
            if (key !== 'gasId' && item[key]) {
              // 使用定时器，防止message信息重叠
              setTimeout(() => {
                const h = this.$createElement
                this.$notify({
                  title: arr1.includes(key) ? '资质不全提醒' : '资质到期提醒',
                  message: h('p', {
                    style: 'display: flex; flex-direction: column;'
                  }, [
                    h('span', { style: 'color: #606266; padding-top: 6px' }, item[key]),
                    h('a',{
                      style: 'color: #3377FF; padding-top: 8px',
                      on: {
                        click: () => {
                          this.goToMore(gasId)
                        }, // 确定按钮的点击事件
                      },
                    }, "立即处理"),
                  ]),
                  duration: 4000
                })
              },50)
            }
          }
        }
      })
    },
    // 资质审核状态
    async gasInfoCheckNotice () {
      const { code, result } = await queryGasInfoCheckNotice()
      if (code !== 200) return
      result.map(item => {
        if (item) {
        let gasId = item.gasId
          setTimeout(() => {
            const h = this.$createElement
            this.$notify({
              title: item.title,
              message: h('p', {
                style: 'display: flex; flex-direction: column;'
              }, [
                h('span', { style: 'color: #606266; padding-top: 6px' }, item.content),
                h('a',{
                  style: 'color: #3377FF; padding-top: 8px',
                  on: {
                    click: () => {
                      this.goToMore(gasId)
                    }, // 确定按钮的点击事件
                  },
                }, item.buttonText),
              ]),
              duration: 4000
            })
          },50)
        }
      })
    },
    // 营业时间修改通知
    async getGasMsg () {
      const { code, result } = await getGasMsg()
      if (code !== 200) return
      result.map(item => {
        if (item) {
          setTimeout(() => {
            const h = this.$createElement
            this.$notify({
              title: item.title,
              message: h('p', {
                style: 'display: flex; flex-direction: column;'
              }, [
                h('span', { style: 'color: #606266; padding-top: 6px' }, item.msg),
                h('a',{
                  style: 'color: #3377FF; padding-top: 8px',
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/gasStationManage/openTime'
                      })
                    }, // 确定按钮的点击事件
                  },
                }, '立即处理'),
              ]),
              duration: 4000
            })
          },50)
        }
      })
    },
    // 违规记录通知
    async violationRecordNotice () {
      const { code, result } = await violationRecordNotice()
      if (code !== 200) return
      result.map(item => {
        if (item) {
          setTimeout(() => {
            const h = this.$createElement
            this.$notify({
              title: item.title,
              message: h('p', {
                style: 'display: flex; flex-direction: column;'
              }, [
                h('span', { style: 'color: #606266; padding-top: 6px' }, item.content),
                h('a',{
                  style: 'color: #3377FF; padding-top: 8px',
                  on: {
                      click: this.goToNoticeMore // 确定按钮的点击事件
                  },
                }, item.buttonText),
              ]),
              duration: 4000
            })
          },50)
        }
      })
    },
    goToMore (gasId) {
      this.$router.push({
        path: '/gasStationManage/gasDetail',
        query: {
          type: 0,
          gasId: gasId,
          flag: true
        }
      })
    },
    // 违规记录
    goToNoticeMore () {
      this.$router.push({ path: '/ruleCenter/violation' })
    },
    // 查询账单提示消息
    async getBillNotice () {
      const { code, result } = await billInvoiceNotification()
      if (code !== 200) return
      result.map(msg => {
        setTimeout(() => {
          this.$notify({
            title: '提示',
            message: msg,
            duration: 5000
          })
        })
      })
    }
  },
  created () {
    // this.isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))
    // 告知函弹窗优先级高于其他业务弹窗，最先触发
    this.getChannelFeeNotice()
    this.ifSupportVoice()
    this.getAdList(2)
    this.getBillNotice()
    const { needRead, ...showRule } = this.pageIndexProtocol
    this.showRule = needRead
    this.ruleContent = showRule
    if (!needRead) return
    this.$track.pageViewEvent('商户规则弹窗', '1637816096')
    clearInterval(this.ruleTimmer)
    this.ruleTimmer = setInterval(()=>{
      this.ruleTimeNum++
    },1000)
    this.$nextTick(() => {
      this.$refs.rulePop.init(showRule)
    })

  },
  mounted () {
    this.isAgreeCheckApi()
    WaterMark((this.userInfo.userId) || '')
    if (!this.cachePages.length) {
      this.$refs.tabs.addTab({
        ...this.$route,
        componentName: this.$route.meta && this.$route.meta.noCache ? '' : this.$route.matched[1].components.default.name
      })
    }
    if(typeof(WebSocket) === "undefined"){
      this.$message.info("您的浏览器不支持socket")
    }else{
      // 实例化socket
      let keyId = ''
      let path = ''
      keyId = this.userInfo.company ? this.userInfo.companyId : this.userInfo.gasId
      // 区分线上和测试开发环境
      if (process.env.NODE_ENV !== 'production') {
        path = `wss://test-websocket.nlktj.com:8090/companyWs?userSource=1&keyId=${keyId}`
      } else {
        path = `wss://websocket.nlktj.com:8090/companyWs?userSource=1&keyId=${keyId}`
      }
      this.socket = new ReconnectingWebSocket(path)
      // 监听socket连接
      this.socket.onopen = this.open
      // 监听socket错误信息
      this.socket.onerror = this.error
      // 监听socket消息
      this.socket.onmessage = this.getMessage
      this.socket.onclose = this.closewebsocket
    }
    //是否需要开启绑定手机号弹窗
    // this.isShowBindPhone()
    this.gasLicenceExpiry()
    this.gasInfoCheckNotice()
    this.violationRecordNotice()
    this.getGasMsg()
  },
  beforeDestroy () {
    clearInterval(this.ruleTimmer)
    this.socket.onclose = this.closewebsocket
  }
}
</script>

<style lang="less">
  @import "~@/styles/variables.less";
  @import "~@/styles/index.less";
  @import url('./style.less');
</style>
